import React from "react";
import { MiniPlayerIcon } from "../Icons";
import { isPictureInPictureSupported } from "../../../context/PlayerContext";

export default ({ onClick = () => { }, disabled }) => {

    const handleClick = () => {
        if (disabled) return;
        onClick();
    }

    if (!isPictureInPictureSupported) return null;

    return <a onClick={handleClick}>
        <MiniPlayerIcon disabled={disabled} />
    </a>
}